import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getCategoryIcon } from "@/components/testing/CategoryCard";
import { CATEGORY_NAMES } from "@/utils/categoryMapping";

interface DevelopmentalCardProps {
  title: string;
  age: number;
  milestones: string[];
  activities: string[];
}

export const DevelopmentalCard = ({ title, age, milestones, activities }: DevelopmentalCardProps) => {
  const Icon = getCategoryIcon(title);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Icon className="h-5 w-5 text-primary" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h4 className="font-semibold mb-2">Key Milestones</h4>
          <ul className="list-disc pl-5 space-y-1 text-base">
            {milestones.map((milestone, index) => (
              <li key={index}>{milestone}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Recommended Activities</h4>
          <ul className="list-disc pl-5 space-y-1 text-base">
            {activities.map((activity, index) => (
              <li key={index}>{activity}</li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};